'use client'

import React from 'react'
import type {BadgeProps as MantineBadgeProps} from '@mantine/core'
import {Badge} from '@mantine/core'
import {ServiceItemCategory} from '@/types/enums/ServiceItem'
import {LabIcon} from '@/components/Icons/LabIcon'
import {SpecialtyIcon} from '@/components/Icons/SpecialtyIcon'
import {HugIcon} from '@/components/Icons/HugIcon'
import {RxPrescriptionIcon} from "@/components/Icons/RxPrescriptionIcon";

type ServiceItemCardBadgeProps = {
    category?: ServiceItemCategory
    iconSize?: number
    iconOnly?: boolean
    /**
     * Overrides the default category-derived label. The category still drives
     * the icon. Use this to render a context-specific label (e.g. "Care" on
     * the SKU detail page) without affecting other call sites.
     */
    label?: string
} & MantineBadgeProps

export function ServiceItemCardBadge({category, iconSize = 16, iconOnly = false, label, ...badgeProps}: ServiceItemCardBadgeProps) {
    const badgeFontColor = 'var(--gm-foreground-fg-secondary, #4F4E4D)'
    const commonBadgeProps = {
        bg: '#2B2A2A0D',
        lts: 0,
        fz: 14,
        fw: 500,
        lh: 20,
        c: badgeFontColor,
        ...badgeProps,
    }
    switch (category) {
        case ServiceItemCategory.medication:
            return (
                <Badge
                    leftSection={
                        <RxPrescriptionIcon color={badgeFontColor}/>
                    }
                    tt={'none'}
                    {...commonBadgeProps}
                >
                    {!iconOnly && (label ?? 'Virtual visit')}
                </Badge>
            )
        case ServiceItemCategory.specialty:
            return (
                <Badge
                    leftSection={<SpecialtyIcon size={iconSize?.toString()} color={badgeFontColor}/>}
                    tt={'none'}
                    {...commonBadgeProps}
                >
                    {!iconOnly && (label ?? 'Specialist review')}
                </Badge>
            )
        case ServiceItemCategory.lab:
            return (
                <Badge
                    leftSection={<LabIcon size={iconSize?.toString()} color={badgeFontColor}/>}
                    tt={'none'}
                    {...commonBadgeProps}
                >
                    {!iconOnly && (label ?? 'Lab test')}
                </Badge>
            )
        default:
        case ServiceItemCategory.visit:
            return (
                <Badge
                    leftSection={<HugIcon size={iconSize?.toString()} color={badgeFontColor}/>}
                    tt={'none'}
                    {...commonBadgeProps}
                >
                    {!iconOnly && (label ?? 'Virtual visit')}
                </Badge>
            )
    }
}
